import { useLanguage } from "../i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div
      className="bg-coal-card border-y border-line-subtle py-3.5 overflow-hidden"
      aria-hidden="true"
      data-testid="marquee-strip"
    >
      <div className="mq-track items-center gap-8 text-xs font-mono uppercase tracking-[0.25em] text-gold-dim">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span>{item}</span>
            <span className="text-white">&bull;</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
